import React from 'react';
import { Button } from '@/ui/Button';
import { Save } from 'lucide-react';
import { SheetBadge } from '@/ui/layout/SheetBadge';
import { Repository } from '@/shared/services/supabaseService';
import { Alert, AlertDescription, AlertTitle } from '@/ui/alert';

interface RepositoryHeaderProps {
  repository: Repository | null;
  activeTab: string;
  saving: boolean;
  onSave: () => void;
  error: string | null;
}

export const RepositoryHeader: React.FC<RepositoryHeaderProps> = ({
  repository,
  activeTab,
  saving,
  onSave,
  error
}) => {
  return (
    <>
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <div>
          <SheetBadge className="mb-4">REPOSITORY_DETAILS</SheetBadge>
          <h1 className="text-3xl md:text-4xl font-bold font-mono tracking-tight uppercase">
            {repository?.name || 'UNKNOWN_REPO'}
          </h1>
          <p className="mt-2 text-muted-foreground font-mono text-sm border-l-2 border-neutral-950 dark:border-neutral-100 pl-3">
            {repository?.fullName}
          </p>
        </div>
        <div className="flex gap-2">
          {activeTab === 'settings' && (
            <Button
              onClick={onSave}
              disabled={saving}
              className="rounded-none font-mono uppercase font-bold bg-neutral-950 text-white dark:bg-white dark:text-black hover:bg-neutral-800 dark:hover:bg-neutral-200"
            >
              <Save className="mr-2 h-4 w-4" />
              {saving ? 'SAVING...' : '[ SAVE_CONFIG ]'}
            </Button>
          )}
        </div>
      </div>

      {error && (
        <Alert variant="destructive" className="mt-6 rounded-none border-2 border-red-500 bg-red-50 text-red-900">
          <AlertTitle className="font-mono font-bold uppercase">ERROR</AlertTitle>
          <AlertDescription className="font-mono text-xs">{error}</AlertDescription>
        </Alert>
      )}
    </>
  );
};
